import { useMaintenance } from "../../../hooks/useMaintenance";
import { PopupModal } from "./PopupModal";

export const MaintenancePopupModal: React.FC = () => {
  const { showMaintenancePopup, popupTitle, handleCloseMaintenancePopup } =
    useMaintenance();

  return (
    <PopupModal
      isOpen={showMaintenancePopup}
      title={popupTitle}
      defaultCloseModal={handleCloseMaintenancePopup}
      buttons={[
        {
          text: "閉じる",
          variant: "filled",
          onClick: handleCloseMaintenancePopup,
        },
      ]}
    />
  );
};
